module.exports = __webpack_public_path__ + "img/_54A2297.d1bc7030.jpg";